import { render, staticRenderFns } from "./SmallCallModalView.vue?vue&type=template&id=6d554db3&scoped=true&"
import script from "./SmallCallModalView.vue?vue&type=script&lang=ts&"
export * from "./SmallCallModalView.vue?vue&type=script&lang=ts&"
import style0 from "./SmallCallModalView.vue?vue&type=style&index=0&id=6d554db3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d554db3",
  null
  
)

export default component.exports